import { CommonModule } from '@angular/common';
import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TeamMember } from "@teammood/team";

@Component({
    selector: 'tm-confirm-dialog',
    templateUrl: './team-member-delete-dialog.component.html',
    styleUrls: ['./team-member-delete-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        MatDialogModule,
        TranslateModule
    ]
})
export class TeamMemberDeleteDialogComponent {

    constructor(
        public dialogRef: MatDialogRef<TeamMemberDeleteDialogComponent, 'disable' | 'delete'>,
        private _translate: TranslateService,
        @Inject(MAT_DIALOG_DATA) public data: TeamMemberDeleteDialogData
    ) {
    }

    close(action?: 'disable' | 'delete'): void {
        this.dialogRef.close(action);
    }

}

export interface TeamMemberDeleteDialogData {
    member: Partial<TeamMember>,
}